import { render, staticRenderFns } from "./IncidenceView.vue?vue&type=template&id=0a9c700a&"
import script from "./IncidenceView.vue?vue&type=script&lang=js&"
export * from "./IncidenceView.vue?vue&type=script&lang=js&"
import style0 from "./IncidenceView.vue?vue&type=style&index=0&id=0a9c700a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports